import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import checkStatus from '../utils/checkStatus';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from "./JwtStore";

export default {
  find(categoryId, themeId) {
    return fetch(api(`timeless/${categoryId}/themes/${themeId}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.TIMELESS_THEME_STORE_FIND_COMPLETE,
        theme: response.data,
      }))
      .catch(dispatchHttpError);
  },
}
